export const ONBOARDING_STEPS = [
  "WELCOME",
  "IDENTITY",
  "ELIGIBILITY",
  "EXPERIENCE",
  "AVAILABILITY",
  "DOCUMENTS",
  "REVIEW",
] as const;

export type OnboardingStep = (typeof ONBOARDING_STEPS)[number];

export const STEP_LABELS: Record<OnboardingStep, string> = {
  WELCOME: "Welcome",
  IDENTITY: "About you",
  ELIGIBILITY: "Eligibility",
  EXPERIENCE: "Experience",
  AVAILABILITY: "Availability",
  DOCUMENTS: "Photo & docs",
  REVIEW: "Review",
};
